import { FetchResult } from 'src/types/TApiQueries';
import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';

export interface QueueStats {
  name: string;
  size: number;
}

export interface QueueStatsResponse {
  timestamp: string;
  hostname: string;
  queues: QueueStats[];
}

export async function getQueueStats(accessToken: string): Promise<FetchResult<QueueStatsResponse>> {
  const url = `${config.hostUrl}/api/v1/stats/queues`;

  return performFetchWithLogging(url, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}
